// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { TURBO_WALLET_BALANCE_TEXT } from "@payment-ui/constants/TurboPayment";
import { ACCESSIBILITY_ROLES } from "@payment-ui/constants";

// styles
import {
    Container,
    NameWrapper,
    TruncatedText,
    InlineBalanceContainer,
    BalanceValueContainer,
    BalanceText,
} from "./styles";
import { TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { CardNumberSubname } from "@payment-ui/widgets/payment-method-name/v4/components/card-number-subname";

interface ITurboPaymentDisplayNameProps {
    superScriptText?: string;
    ariaLabel?: string;
    displayName: string;
    inlineBalanceMeta?: {
        show: boolean;
        value?: string | number;
    };
    cardSubName?: string;
}

function TurboPaymentDisplayName(props: ITurboPaymentDisplayNameProps) {
    const { superScriptText, ariaLabel, displayName, inlineBalanceMeta, cardSubName } = props;

    return (
        <Container>
            {/* role="button" is assigned just for accessibility purpose.
            It enables user to navigate through just by the names of payment
            methods and use onClick event from wrapper div */}
            {superScriptText && (
                <Text color="text_Med_Emphasis" variant="V2.body2.neutral.regular">
                    {superScriptText}
                </Text>
            )}
            <NameWrapper aria-label={ariaLabel} tabIndex={0} role={ACCESSIBILITY_ROLES.GENERIC}>
                <TruncatedText data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.DISPLAY_NAME}>
                    <Text variant="V2.body1.neutral.medium">{displayName}</Text>
                </TruncatedText>
                {cardSubName && <CardNumberSubname cardNumber={cardSubName} isTurboPaymentMethod={true} />}
                {inlineBalanceMeta?.show && inlineBalanceMeta.value && (
                    <InlineBalanceContainer
                        data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.INLINE_BALANCE_CONTAINER}
                    >
                        <BalanceText variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                            {TURBO_WALLET_BALANCE_TEXT}
                        </BalanceText>
                        <BalanceText variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                            <BalanceValueContainer>{String(inlineBalanceMeta.value)}</BalanceValueContainer>
                        </BalanceText>
                    </InlineBalanceContainer>
                )}
            </NameWrapper>
        </Container>
    );
}

export default memo(TurboPaymentDisplayName);
